import React from 'react';
import { SubPageServiceTheme } from './SubPageServiceTheme';
import { Text } from '../components/Text';
import { SubPageTheme } from '../components/SubPageTheme';
import { Service } from './PageServices';

export const PageServiceCreatingContracts = () => {
    return (
        <SubPageTheme headerBg="/resources/images/TOP_Tworzenie_I_OPINIOWANIE_UMOW.jpg">
            <SubPageServiceTheme header="Tworzenie i opiniowanie umów" activeService={Service.CreatingContracts}>
                <Text>
                    Prawnik dba o przygotowanie umowy, które jest zrozumiała dla obu stron. Moim zdaniem jest, aby treść
                    całej umowy nie budziła żadnych wątpliwości i nie pozostawiała dodatkowego pola do interpretacji, a
                    przede wszystkim była zgodna z prawem i zasadami współżycia społecznego. Odwzorowuje przy tym
                    intencję stron oraz ich interesy. Przestrzeganie tych wytycznych daje Klientom poczucie, że
                    otrzymują umowę wg aktualnego stanu prawnego, która wpływa na bezpieczeństwo ich interesów.
                </Text>
            </SubPageServiceTheme>
        </SubPageTheme>
    );
};
